import React from "react";
import "./BusinessThreeProduct2.scss";

const products = [
  {
    img: "https://www.ooberpad.com/cdn/shop/files/DevialetPhantomI108dBCustom_2_b8119e9e-4e9a-44c5-9558-2bcab7beced6.webp?v=1692864840&width=940",
    title: "Devialet Astra Light Bronze | High-end integrated amplifier",
    price: "From 1,790,000.00",
  },
  {
    img: "https://www.ooberpad.com/cdn/shop/files/EpsonEH-LS800B_d0474e2f-6fa8-4ab8-a8d0-c5967cb56ba9.jpg?v=1683276203&width=940",
    title: "Devialet Dione Dolby Atmos Soundbar",
    price: "From 219,000.00",
  },
  {
    img: "https://www.ooberpad.com/cdn/shop/files/BenQTK710STi_1.webp?v=1738217573&width=940",
    title: "Devialet Phantom Theater 7 & StormAudio – ISP Evo Sound Processor",
    price: "From 319,000.00",
  },
  {
    img: "https://www.ooberpad.com/cdn/shop/files/Devialet_Astra_Dual-Light_Bronze.webp?v=1732528144&width=940",
    title: "Devialet Phantom Theater 9 & StormAudio – ISP Evo Sound Processor",
    price: "From 119,000.00",
  },
  {
    img: "https://www.ooberpad.com/cdn/shop/files/DevialetDione_33ecd383-81f4-4ecc-9654-ec23df7eefc4.webp?v=1749462654&width=940",
    title: "Devialet Mania Portable Bluetooth Speaker",
    price: "From 99,000.00",
  },
  {
    img: "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcTxjmHJTc3DK8eT9DzPz9wZFvzheTpTZWpASydJYhF0LYheNyn2-uUgtJZYt-1DPU7M4aDn_UWIVBax-0LaZNMjn_YLutWEzIMwh9DNSlxQzrYDYZgYTYLv",
    title: "Devialet Phantom II 98 dB Opera de Paris Wireless Speaker",
    price: "190,000.00",
  },
];

const BusinessThreeProduct2 = () => {
  return (
    <section className="devialet-section">
      <div className="top-row">
        <div className="promo">
          <p className="tagline">Explore Brand</p>
          <h2>Top Products</h2>
          <button>Know More</button>
        </div>
        {products.slice(0, 2).map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.img} alt={item.title} />
            <p className="title">{item.title}</p>
            <p className="price">{item.price}</p>
          </div>
        ))}
      </div>

      <div className="bottom-row">
        {products.slice(2).map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.img} alt={item.title} />
            <p className="title">{item.title}</p>
            <p className="price">{item.price}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BusinessThreeProduct2;
